<template>
  <div class="prove-wrapper">
    <el-form
      ref="formDate"
      :model="formDate"
      :rules="editRules"
      :label-width="`${adaptationVars.formLabelWidth}px`"
      class="demo-ruleForm"
      label-position="left"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="随机因子" prop="opening">
            <el-input v-model="formDate.opening" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="数据信息" prop="value">
            <el-input v-model="formDate.value" placeholder="请输入非负整数"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item v-if="formDate.commitment" label="承诺" prop="path">
            <el-input v-model="formDate.commitment" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item v-if="formDate.proof" label="证明" prop="path">
            <el-input v-model="formDate.proof" type="textarea" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item>
            <el-button type="primary" @click="handleProve()">确定</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'Index',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 100
  },
  data() {
    return {
      formDate: {
        value: null,
        params: '',
        opening: '',
        commitment: '',
        proof: ''
      },
      orgOtion: [],
      editRules: {
        value: [
          { required: true, message: '请输入数值', trigger: 'blur' },
          { pattern: /^\d+$/, message: '请输入非负整数', trigger: 'blur' }
        ]
      },
      adaptationVars: {
        formLabelWidth: 100
      }
    }
  },
  mounted() {
    this.formDate.opening = localStorage.getItem('opening')
  },
  methods: {
    handleProve() {
      this.$refs.formDate.validate().then(valid => {
        if (valid) {
          this.formDate.value = Number(this.formDate.value)
          this.$apis.bulletproofs.prove(this.formDate).then(res => {
            if (res) {
              this.formDate.params = res.data.params
              this.formDate.commitment = res.data.commitment
              this.formDate.proof = res.data.proof
              this.$message.success('生成证明成功!')
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.prove-wrapper {
  .el-row {
    margin: 0 calc(0px - var(--base-size-16));

    .el-col {
      padding: 0 var(--base-size-16);
    }
  }
}

</style>
